import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/Main/Buttons/ScrollToTop';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';

const App: React.FC = () => {
  const [selectedService, setSelectedService] = useState<null | string>(null);

  return (
    <Router>
      <ScrollToTop />
      <Header onServiceClick={(serviceName) => setSelectedService(serviceName)} />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
